import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import AcademicsPage from "./pages/AcademicsPage";
import StagePage from "./pages/StagePage";
import CampusPage from "./pages/CampusPage";
import AdmissionsPage from "./pages/AdmissionsPage";
import DownloadsPage from "./pages/DownloadsPage";
import FaqPage from "./pages/FaqPage";
import ContactPage from "./pages/ContactPage";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/academics" element={<AcademicsPage />} />
            <Route path="/academics/:slug" element={<StagePage />} />
            <Route path="/campus" element={<CampusPage />} />
            {/* merged pages — keep old paths working */}
            <Route path="/infrastructure" element={<Navigate to="/campus" replace />} />
            <Route path="/campus-life" element={<Navigate to="/campus" replace />} />
            <Route path="/admissions" element={<AdmissionsPage />} />
            <Route path="/downloads" element={<DownloadsPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
